"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineageCountsCacher = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
/**
 * This component caches the values of two "counts" objects.
 * It also passes through a single "loading" boolean (without caching it).
 *
 * For either (or both) "counts" objects, a new value can be provided, or it can be left undefined.
 * Providing a new value will populate the cache and pass the new value to the children.
 * Leaving a value undefined will cause the cached value to be passed to the children.
 *
 * The cached value for each object is initially null.
 */
class LineageCountsCacher extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            unfilteredCounts: props.newUnfilteredCounts || null,
            filteredCounts: props.newFilteredCounts || null,
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            unfilteredCounts: nextProps.newUnfilteredCounts !== undefined
                ? nextProps.newUnfilteredCounts
                : prevState.unfilteredCounts,
            filteredCounts: nextProps.newFilteredCounts !== undefined
                ? nextProps.newFilteredCounts
                : prevState.filteredCounts,
        };
    }
    render() {
        return this.props.children({
            countsLoading: this.props.countsLoading,
            unfilteredCounts: this.state.unfilteredCounts,
            filteredCounts: this.state.filteredCounts,
        });
    }
}
exports.LineageCountsCacher = LineageCountsCacher;
//# sourceMappingURL=LineageCountsCacher.js.map